import * as h2Api from '../../h2Api'
import { appendSearchResults, initSearchResults } from '../search'

export const WORKKEYS_RESULTS = 'WORKKEYS_RESULTS'
export const ADD_WORKKEYS_RESULTS = 'ADD_WORKKEYS_RESULTS'

export const loadWorkKeysResults = filters => dispatch => {
  return dispatch(
    h2Api.post(`/assessment/workkeys/results`, { filters })({ type: WORKKEYS_RESULTS })
  ).then(v => {
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentWorkKeysResults = filters => (
  startIdx,
  endIdx
) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(
      `/assessment/workkeys/results`,
      updatedJson
    )({ type: ADD_WORKKEYS_RESULTS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}
